<div class="m-4 fx-row x-center">

  <!-- Container for the Photo Order: Centered on page with max width of 1200px -->
  @if (photoOrder$ | async; as photoOrder) {
    <div class="fx-column fx-0-1" [style.width]="'1200px'">
      <h4 class="font-weight-bold">Photos & Multimedia</h4>
      <div>
        <span class="font-weight-bold">Order:&nbsp;</span>
        <span>{{photoOrder.photoOrderId}}</span>
      </div>
      <div>
        <span class="font-weight-bold">Address:&nbsp;</span>
        @if (photoOrder.propertyAddress) {
          <span>
            {{photoOrder.propertyAddress | address}}
          </span>
        }
      </div>
      <div>
        <span class="font-weight-bold">Agent:&nbsp;</span>
        <span>{{photoOrder.agentName}}</span>
      </div>
      <div>
        <span class="font-weight-bold">Agent Brand:&nbsp;</span>
        <span>{{photoOrder.brandCode}}</span>
      </div>
      <div>
        <span class="font-weight-bold">Agent Area:&nbsp;</span>
        <span>{{photoOrder.area}}</span>
      </div>
      @if (photoOrder.appointment) {
        <div>
          <span class="font-weight-bold">Appointment:&nbsp;</span>
          <span>{{photoOrder.appointment.scheduledAt | date:'short' : photoOrder.appointment?.timezoneOffset}} {{photoOrder.appointment?.timezone}}</span>
        </div>
      }
      @if (photoOrder.package) {
        <div>
          <div >
            <span class="font-weight-bold">Package:&nbsp;</span>
            <span>{{photoOrder.package}}</span>
          </div>
        </div>
      }
      <div>
        <span class="font-weight-bold">Selected Options:&nbsp;</span>
        <span>{{photoOrderSelectedOptions}}</span>
      </div>
      @if (photoOrder.appointment && photoOrder.appointment.lockbox) {
        <div>
          <div >
            <span class="font-weight-bold">Code:&nbsp;</span>
            <span>{{photoOrder.appointment.lockbox.code}}</span>
          </div>
          <div  class="appointment-location">
            <span class="font-weight-bold">Location:&nbsp;</span>
            <span>{{photoOrder.appointment.lockbox.location}}</span>
          </div>
        </div>
      }
      @if (photoOrder.appointment) {
        <div class="pb-xl">
          <span class="font-weight-bold">Comments:&nbsp;</span>
          <span>{{photoOrder.appointment.comments}}</span>
        </div>
      }
      <lc-navigation-tabs [activeId]="activeId$ | async" [tabs]="tabs" />
    </div>
  }
</div>
